import { render, staticRenderFns } from "./GlobalKeyValueItemConfiguration.vue?vue&type=template&id=41cb2a34"
import script from "./GlobalKeyValueItemConfiguration.vue?vue&type=script&lang=js"
export * from "./GlobalKeyValueItemConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports